<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonCategory.saveError">
    <template slot="center">
      <el-form
        :ref="formRef"
        :model="formData"
         label-width="20em">

        <template v-for="personCategory in _get(PersonCategory, 'data', [])">
          <section v-if="personCategory.field_type === 'section'">
            <h4 class="section-title">{{ personCategory.name }}</h4>
            <el-form-item
               v-for="personSubCategory in personCategory.SubCategories"
              :label="personSubCategory.name"
              :key="personSubCategory.id">
              <component
                 v-bind:is="'form-input-'+personSubCategory.field_type"
                :input="personSubCategory"
                :value="formData.PersonCategories"
                :disabled="!edit"
                :clearable="true"
                @set:value="setValueEvent">
              </component>
            </el-form-item>
          </section>

          <section v-else>
            <h4 class="section-title">{{ $t(`label.${code}`) }}</h4>
            <el-form-item
              :label="personCategory.name"
              :key="personCategory.id">
              <component
                 v-bind:is="'form-input-'+personCategory.field_type"
                :input="personCategory"
                :value="formData.PersonCategories"
                :disabled="!edit"
                :clearable="true"
                @set:value="setValueEvent">
              </component>
            </el-form-item>
          </section>
        </template>

      </el-form>
    </template>
    <!-- end ~ center -->

    <template slot="footer">
      <nav class="footer-row">
        <el-button :disabled="!isDataChanged" :loading="isSaving" type="primary" size="small" @click="submitForm">{{ $t('label.save_changes') }}</el-button>

        <el-button type="text" size="small" @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>
    <!-- end ~ footer -->
  </nuttrema-layout-form-standard>
</template>

<script>
import Vue from 'vue';
import { each, isNil } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import FormInputGroup from './form-input/cmpt-form-input-group';
import FormInputSelect from './form-input/cmpt-form-input-select';
import FormInputComplex from './form-input/cmpt-form-input-complex';
import FormInputSimple from './form-input/cmpt-form-input-simple';
import FormInputText from './form-input/cmpt-form-input-text';

export default {
  name: 'form-participant-category',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    PersonCategory: {
      required: true,
      default: null,
    },
  },
  components: {
    FormInputText,
    FormInputGroup,
    FormInputSelect,
    FormInputSimple,
    FormInputComplex,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        PersonCategories: {},
      },
    };
  },
  methods: {
    setValueEvent(params) {
      Vue.set(this.formData.PersonCategories, params.code, params.data);
    },
    getFormData() {
      const payload = {
        person_categories: [],
      };

      each(this.formData.PersonCategories, (category) => {
        if (!isNil(category.value) && category.value !== '') payload.person_categories.push({ id: category.id, value: category.value });
      });

      return payload;
    },
  },
  created() {
    this.stateData = this.PersonCategory;
    this.formRef = 'form-participant-consultation';
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/consultation/form-participant-consultation.vue